import { EmailTemplateQueries } from '@frontend/api-email-template';
import { EmailPreviewModal } from '@frontend/email-preview-modal';
import { useTranslation } from '@frontend/i18n';
import { BulkEmailPrefixes } from '@frontend/tracking-prefixes';
import { ContentLoader } from '@frontend/design-system';
import { useComposeTemplates } from '../../hooks/use-compose-templates';
import { LaunchCards } from './launch-cards';
import { TemplateSection } from './template-section';

export const BulkEmailComposeView = () => {
  const { t } = useTranslation('bulk-messaging');
  const {
    activeFilter,
    deviceSizeProps,
    handleCustomTemplateClick,
    handleDelete,
    handleDuplicate,
    handleView,
    handleWeaveTemplateClick,
    hasMore,
    isDeleting,
    isDuplicating,
    isFetchingMore,
    isLoading,
    isTemplateActionLoading,
    loadMore,
    previewModalProps,
    previewTemplate,
    searchQuery,
    setActiveFilter,
    setPreviewHtml,
    setSearchQuery,
    transformedText,
    visibleTemplates,
  } = useComposeTemplates();

  return (
    <div css={{ position: 'relative' }}>
      <ContentLoader
        show={isDuplicating || isDeleting || isTemplateActionLoading}
        message={isTemplateActionLoading ? t('Loading template...') : undefined}
      />
      <LaunchCards />
      <TemplateSection
        activeFilter={activeFilter}
        hasMore={hasMore}
        isFetchingMore={isFetchingMore}
        isLoading={isLoading}
        loadMore={loadMore}
        onCustomTemplateClick={handleCustomTemplateClick}
        onDelete={handleDelete}
        onDuplicate={handleDuplicate}
        onFilterChange={setActiveFilter}
        onSearchChange={setSearchQuery}
        onView={handleView}
        onWeaveTemplateClick={handleWeaveTemplateClick}
        searchQuery={searchQuery}
        visibleTemplates={visibleTemplates}
      />
      {previewModalProps.show && (
        <EmailPreviewModal
          deviceSizeProps={deviceSizeProps}
          isUseTemplateButtonVisible={true}
          modalProps={previewModalProps}
          onUseTemplate={(_isEditing: boolean, templateId: string) => {
            if (previewTemplate && EmailTemplateQueries.isSystemEmailTemplate(previewTemplate)) {
              handleWeaveTemplateClick(templateId);
            } else {
              handleCustomTemplateClick(false, templateId);
            }
          }}
          previewHtml={transformedText}
          setPreviewHtml={setPreviewHtml}
          templateId={previewTemplate?.id}
          trackingIdPrefix={BulkEmailPrefixes.Templates}
        />
      )}
    </div>
  );
};
